<div class="single-form" fxLayout="column" fxLayoutAlign="space-between center" fxFlexFill>
  <div fxFlex fxLayout="row" fxLayoutAlign="center center">
    <mat-card class="padding-25 mat-elevation-z5" fxFlex="370px" fxFlex.sm="80%" fxFlex.lt-sm="90%">
      <form [formGroup]="loginForm" fxLayout="column" (ngSubmit)="loginForm.valid && onSubmit(loginForm.value)" autocomplete="off" autocorrect="off" fxLayoutGap="25px" novalidate>

        <!--Image Logo-->
        <img class="logo" src="assets/images/swiftrewards-icon.png" alt="Swift Rewards Logo" id="id_login_img_logo">

        <!--Statement Logo-->
        <!-- <h2 class="mat-display-1 mat-primary-color">E-Science Corporation</h2> -->

        <mat-label class="mat-warn-color mat-subheading-1" *ngIf="errorMessage">
          {{errorMessage}}
        </mat-label>

        <mat-form-field>
          <input id="id_login_txtbox_user" matInput [placeholder]="'LABEL_USERNAME' | translate" formControlName="username" autocomplete="off" required>
          <mat-error *ngIf="loginForm.controls['username'].hasError('required')">
            {{ 'MSG_ERROR_USERNAME_REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <input id="id_login_fld_pass" matInput [placeholder]="'LABEL_PASSWORD' | translate" formControlName="password" [type]="isPasswordShown ? 'text' : 'password'"
            required>
          <!-- <mat-icon *ngIf="loginForm.controls['password'].value" [svgIcon]="isPasswordShown ? 'eye-off' : 'eye'" -->
          <mat-icon id="id_login_btn_showpass" [svgIcon]="isPasswordShown ? 'eye-off' : 'eye'"
            (click)="isPasswordShown = !isPasswordShown" matSuffix>
          </mat-icon>

          <mat-error *ngIf="loginForm.controls['password'].hasError('required')">
            {{ 'MSG_ERROR_PASSWORD_REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>

        <button id="id_login_btn_login" color="primary" [disabled]="isSubmitting" mat-raised-button type="submit">
          <div fxLayout fxLayoutAlign="center center">
            <span class="padding-right-2">
              {{ (isSubmitting ? 'LABEL_LOGGING_IN' : 'LABEL_LOGIN') | translate }}
            </span>
            <mat-spinner [diameter]="20" color="primary" *ngIf="isSubmitting"></mat-spinner>
          </div>
        </button>

        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center">
          <!-- <mat-checkbox formControlName="rememberMe">
            <mat-label>{{ 'REMEMBER_ME' | translate }}</mat-label>
          </mat-checkbox> -->

          <!-- [queryParams]="loginForm.controls['username'].valid ? { username: loginForm.controls['username'].value } : {}" -->
          <button mat-button 
            id="id_login_btn_forgot_pass"
            type="button"
            routerLink="../forgot-password" 
            color="primary">
            {{ 'LABEL_FORGOT_PASSWORD' | translate }}
          </button>
        </div>

        <!-- <div fxLayout="column" fxLayout.lt-sm="column" fxLayoutAlign="space-around center">
          <mat-label class="mat-body-2 center">
            {{ 'MSG_DONT_HAVE_ACCOUNT' | translate}}
          </mat-label>
          <button mat-button routerLink="../register" color="primary" class="mat-body mat-primary-color">
            {{ 'REGISTER' | translate }}
          </button>
        </div> -->
      </form>
    </mat-card>
  </div>
  
  <div fxFlexAlign="end" class="width-100">
    <esc-footer></esc-footer>
  </div>
</div>